// types.js

// project_type_show: true  → Show Type dropdown → then Category → then form
// project_type_show: false → Hide Type dropdown entirely → Show Category directly → then form

export const PROJECT_TYPE_SHOW = false; // ← change this one flag to control

export const propertyTypes = [
  { id: 1, type_name: "Residential" },
  { id: 2, type_name: "Commercial"  },
];

export const projectTypes = [
  { id: 1, type_name: "Residential", is_other: false },
  { id: 2, type_name: "Commercial",  is_other: false },
  { id: 3, type_name: "Other",       is_other: false  },
];